<lib-collection-item-list-page [id]="id"></lib-collection-item-list-page>